import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function dropdownList(theme: Theme): ComponentStyle {
  return {
    componentName: 'dropdownList',
    baseStyle: {
      border: `1px solid ${theme.colors.border}`,
      backgroundColor: theme.colors.foreground,
      borderRadius: theme.sizes['0'],
      color: theme.colors.text,
      boxSizing: 'border-box',
      fontSize: theme.sizes['-1'],
      fontWeight: 500
    }
  };
}
